import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesOrder, SalesOrderCreate, SalesOrderFilter } from '../data/salesOrder';

export function createSalesOrderService(client: AxiosInstance) {
  return createCrudService<SalesOrder, SalesOrderCreate, SalesOrderFilter>(client, "/sales/SalesOrder", "salesOrderId");
}

export type SalesOrderService = CrudService<SalesOrder, SalesOrderCreate, SalesOrderFilter>;
